export default "__VITE_ASSET__4b208c8f__"